export default {
  getKanbanCardsList(state) {
    return state.kanban_cards
  },
  getCrmStepsList(state) {
    return state.crm_steps
  },
  getProductsList(state) {
    return state.products
  },
  getOneCrmInfo(state) {
    return state.one_crm_info
  },
  getDashboardInfo(state) {
    return state.dashboard
  },
  getLeadExchange(state) {
    return state.lead_exchange
  },
  getCrmStepsHistory(state) {
    return state.steps_history
  },

  getLid: state => state.lid,
}
